import { Component, effect, EventEmitter, input, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { concatMap, of, tap } from 'rxjs';
import { CalendarEventsRequest } from 'src/app/models/calendar-events-request.interface';
import { Settlement } from 'src/app/models/settlement.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-add-unit',
  template: `
    <ng-template #modalAddUnit let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Agregar unidad</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <app-form-unit
          [settlementBaseData]="settlement()"
          [floor_id]="floor_id" 
          (updateUnit)="createUnit($event)" 
          (cancelUnit)="dismiss()"
        ></app-form-unit>
      </div>
    </ng-template>    
  `,
  styleUrls: []
})
export class ModalAddUnitComponent {
  settlement = input<Settlement | null>(null);
  @Input() floor_id: any;
  @Output() onUnitCreated = new EventEmitter<any>();
  @Output() updateDismiss = new EventEmitter<any>();
  @ViewChild('modalAddUnit') modalAddUnit !: any;

  private modalRef: NgbModalRef | undefined;

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    private modalService: NgbModal
  ) {
    effect(() => {
      const settlement = this.settlement();
      if (settlement) {
        console.log(settlement);
      }
    })
  }

  openModal(modalContent: TemplateRef<any>) {
    if (!this.floor_id) {
      console.warn('ModalAddUnitComponent: No floor_id was provided when opening modal');
    }
    this.modalRef = this.modalService.open(modalContent);
  }

  createUnit(form: any) {
    this.store.createUnit(form)
      /* .pipe(
        concatMap(
          unitCreation => this.store.unitHasStartOperationsDate(unitCreation.data.id)
            .pipe(
              concatMap((validation: any) => {
                if (Array.isArray(validation.data) && validation.data.length === 0) {
                  const payload: CalendarEventsRequest = {
                    event_id: 6,
                    unit_id: unitCreation.data.id,
                    event_date: form.startOperationsDate
                  };
                  return this.store.saveCalendarEvent(payload);
                } else {
                  return of({
                    success: true,
                    startOperationDate: ''
                  })
                }
              })
            )
        )
      ) */
      .subscribe({
        next: (_data: any) => {
          this.toastr.success('Unidad creada exitosamente', 'Éxito');
          this.updateDismiss.emit();
          this.dismiss();
        },
        error: (error: any) => {
          this.toastr.error('Error al crear la unidad', 'Error');
        }
      });
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
